import { IList } from 'typings/DeepIMap';
import * as Models from 'models';
import { isRegularRelation } from 'utils/relations/isRegularRelation';

export function getParent(
  relationId: string,
  relations: Models.RelationsMap | Models.LayeredRelationsMap,
): {
    parent: Models.RowRelationMap | Models.ColumnRelationMap;
    position: number;
  } {
  let position = -1;

  const parent = relations.find((relation: Models.RelationMap | Models.LayeredRelationMap) => {
    if (isRegularRelation(relation)) {
      return false;
    }

    // @ts-expect-error: immutable types confusion
    const relationIds: IList<string> = relation.get('relationIds', []);
    position = relationIds.indexOf(relationId);

    return position !== -1;
  }) as Models.RowRelationMap | Models.ColumnRelationMap;

  return {
    parent,
    position,
  };
}
